module.exports = __webpack_public_path__ + "img/online.50abc0bd.png";